function save(sess, event) {
    const {Project} = sess;
    return Project.create(event)
}

function setFileName(sess, {filename, projectId}) {
    const {Project} = sess;
    Project.withId(projectId).update({fileName: filename});
}

function setProgress(sess, {progress, projectId}) {
    const {Project} = sess;
    Project.withId(projectId).update({
        uploadProgress: progress,
    });
}

function setStatus(sess, {status, projectId}) {
    const {Project} = sess;
    Project.withId(projectId).update({
        fileStatus: status,
    });
}

function saveCourseProjectOverview(sess, courseId, overviewData) { 
    const { ProjectOverview } = sess;
    ProjectOverview.create({
        ...overviewData,
        course: courseId
    });
}

function cleanAllCourseProjectOverview(sess, courseId) { 
    const { Course } = sess;
    Course.withId(courseId).projectOverviews.all().delete();
}

export default {
    save,
    setFileName,
    setProgress,
    setStatus,
    saveCourseProjectOverview,
    cleanAllCourseProjectOverview
}